const apiBaseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:8000";
const environment = process.env.REACT_APP_ENVIRONMENT || "";
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

export { apiBaseUrl, environment, googleClientId };
